// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3Uxiu","footer":"ModalFilter_footer__3XGT7"};